import React, { useState, useEffect } from "react";
import { Utensils } from "lucide-react";

const ImagePreview = ({ src, alt, className }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    let timer;
    if (loading) {
      timer = setTimeout(() => {
        setLoading(false);
      }, 30000);
    }
    return () => clearTimeout(timer);
  }, [loading]);

  return (
    <>
      {/* Thumbnail */}
      {!imgError && src ? (
        <img
          src={src}
          alt={alt}
          onClick={() => setOpen(true)}
          onError={() => setImgError(true)}
          className={`cursor-pointer hover:scale-105 transition ${className}`}
        />
      ) : (
        <div
          className={`flex items-center justify-center bg-gray-100 border rounded-lg ${className}`}
        >
          <Utensils size={22} className="text-gray-400" />
        </div>
      )}

      {/* Modal */}
      {open && !imgError && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fadeIn"
          onClick={() => setOpen(false)}
        >
          {/* Close Button */}
          <button
            onClick={() => setOpen(false)}
            className="fixed top-4 right-4 z-50 bg-white w-10 h-10 flex justify-center items-center rounded-full text-lg shadow-lg hover:bg-gray-100"
          >
            ✕
          </button>

          {/* Image Container */}
          <div
            className="relative max-w-[95vw] max-h-[90vh] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Shimmer */}
            {loading && (
              <div className="absolute inset-0 rounded-lg shimmer"></div>
            )}

            {/* Image */}
            <img
              src={src}
              alt={alt}
              onLoad={() => setLoading(false)}
              onError={() => setImgError(true)}
              className={`max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl transition-opacity duration-300 ${
                loading ? "opacity-0" : "opacity-100"
              }`}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePreview;
